module.exports = __webpack_public_path__ + "img/Nature-text.b37882bc.jpg";